import { render, staticRenderFns } from "./ContentSectionManabi.vue?vue&type=template&id=784c7aaf&scoped=true&"
import script from "./ContentSectionManabi.vue?vue&type=script&lang=ts&"
export * from "./ContentSectionManabi.vue?vue&type=script&lang=ts&"
import style0 from "./ContentSectionManabi.vue?vue&type=style&index=0&id=784c7aaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c7aaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
